import ButtonView from './ButtonView';

export default ButtonView;
